// World 12 (Vault) — second post-launch expansion world. Builds on W11
// Keep by doubling the lock density (2 locked tiles per color vs. W11's 1)
// and bumping the depth ceiling to d=8. The mechanic pressure is what
// carries the world: with twice the locks, players must plan two unlock
// reads per color, which interacts richly with the cascade logic.
//
// GOTCHA — ships at 9 levels, not 10. The r=4 tileCount-14 config produced
// zero solvable candidates at 2-locks-per-color + 180s solver budget (see
// logs/gen-w12.log: 99 truncated out of 100 attempts). Rather than burn
// another 4h of walltime on a fifth config run with different params, we
// accept the 9-level ship. Close enough to convention; players rarely
// count. If the gap ever matters, regenerate with a wider cfg3 (tileCount
// down to 13 or back to r=3) — easy tune in tools/world-specs.mjs.
//
// Generator: tools/generate-parallel.mjs --world 12. Seed 0xaebcd000.
// 9 candidates pooled across 4 configs in ~18075s (~5h walltime).
import type { LevelDef } from '@tessera/engine';
import { WORLD_12_GENERATED } from './world12-generated';

export const WORLD_12_LEVELS: LevelDef[] = [...WORLD_12_GENERATED];
